import { DeleteUserMediaOutDto, DeleteUserMediaInDto } from '../../../types/user.dto'

export const DELETE_USER_MEDIA = 'DELETE_USER_MEDIA'
export const DELETE_USER_MEDIA_SUCCESS = 'DELETE_USER_MEDIA_SUCCESS'
export const DELETE_USER_MEDIA_ERROR = 'DELETE_USER_MEDIA_ERROR'
export const RESET_DELETE_USER_MEDIA = 'RESET_DELETE_USER_MEDIA'

export interface DeleteUserMedia {
  type: typeof DELETE_USER_MEDIA
  payload: DeleteUserMediaOutDto
}

export interface DeleteUserMediaSuccess {
  type: typeof DELETE_USER_MEDIA_SUCCESS
  payload: DeleteUserMediaInDto
}

export interface DeleteUserMediaError {
  type: typeof DELETE_USER_MEDIA_ERROR
  payload: string | boolean
}

export interface ResetDeleteUserMedia {
  type: typeof RESET_DELETE_USER_MEDIA
  payload: null
}

export interface State {
  data: DeleteUserMediaInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = DeleteUserMedia | DeleteUserMediaSuccess | DeleteUserMediaError | ResetDeleteUserMedia
